import Model from '@ember-data/model';

import { attr, belongsTo } from '@ember-data/model';

export default class ModelRunMemberModel extends Model {
  @attr('string') description;
  @attr('string') modelRunMemberSourceCode;
  @attr('date') createDate;

  @belongsTo('model-run', { async: true, inverse: 'modelRunMembers' }) modelRun;
}
